import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
  standalone: true
})
export class SafePipe implements PipeTransform {

  private readonly _domSanitizer = inject(DomSanitizer);

  public transform(
    value: string,
    type: 'html' | 'style' | 'script' | 'url' | 'resourceUrl'
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this._domSanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this._domSanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this._domSanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this._domSanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this._domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
  }
}
